import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab82879e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view monitoring" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientList = _resolveComponent("PatientList")!
  const _component_Pagenation = _resolveComponent("Pagenation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PatientList),
    _createVNode(_component_Pagenation)
  ]))
}